import type { IPoint } from '@/modules/Editor/point'
import type { PolygonToRasterResult } from '@/modules/Editor/plugins/mask/utils/polygonToRaster'
import { toWorker } from '@/modules/Editor/utils/workers/toWorker'
import { Actions } from './types'
import Worker from './worker?worker'
import type { DFSFillingResult, DFSParams } from '@/modules/Editor/plugins/fill/runDFSScan'

export class RasterWorker {
  private worker: Worker
  private toWorker: ReturnType<typeof toWorker>

  private dicomVoxelBuffer: Int16Array | undefined
  setDicomVoxelBuffer(buffer: Int16Array): void {
    this.dicomVoxelBuffer = buffer
  }
  hasDicomVoxelBuffer(): boolean {
    return !!this.dicomVoxelBuffer
  }

  constructor() {
    this.worker = new Worker()
    this.toWorker = toWorker(this.worker)
  }

  async polygonToRaster(path: IPoint[]): Promise<PolygonToRasterResult> {
    const result = await this.toWorker.postMessage<PolygonToRasterResult>(Actions.polygonToRaster, {
      path,
    })

    if (!result) {
      throw new Error('Failed to convert polygon to raster')
    }

    return result
  }

  async fillFromPointOnRaster(
    params: Omit<DFSParams, 'buffer'>,
  ): Promise<DFSFillingResult | undefined> {
    const result = await this.toWorker.postMessage<DFSFillingResult>(
      Actions.fillFromPointOnRaster,
      {
        ...params,
        buffer: this.dicomVoxelBuffer,
      },
    )

    return result
  }

  cleanup(): void {
    this.toWorker.cleanup()
    this.worker.terminate()
    this.dicomVoxelBuffer = undefined
  }
}
